import MaterialListItemText, {
    ListItemTextProps,
} from '@mui/material/ListItemText';

export function ListItemText(props: ListItemTextProps) {
    return (
        <MaterialListItemText
            data-testid={'ListItemText-container'}
            {...props}
        ></MaterialListItemText>
    );
}

export default ListItemText;
